import { render, staticRenderFns } from "./SiteMenu.vue?vue&type=template&id=5854bd1f&scoped=true"
import script from "./SiteMenu.vue?vue&type=script&lang=js"
export * from "./SiteMenu.vue?vue&type=script&lang=js"
import style0 from "./SiteMenu.vue?vue&type=style&index=0&id=5854bd1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5854bd1f",
  null
  
)

export default component.exports